export default "__VITE_ASSET__O$8Vm_oy__"